import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as accountActions from '../../accountPage.actions';
import { selectors as userInfoSelectors } from '../../../../common/userInfo';
import { selectors as bookmakersListSelectors } from '../../../../common/bookmakersList';
import { selectors as transitionRouterSelectors } from '../../../../common/transitionRouter';
import ExternalAccount from '../../../../common/externalAccount';
import BetHistoryIntegrated from './components/BetHistoryIntegrated';
import {
    currentPageItemsSelector,
    pageIsLoadingSelector,
    betHistoryErrorsSelector,
    currentPageSelector,
    hasNextPageSelector,
    isPageAfterNextRequestedSelector,
} from '../../betHistory.selectors_deprecated';
import { BET_HISTORY_PAGE_LENGTH } from '../../betHistory.constants';
import { betPropTypes } from './BetPropTypes';
import './styles.scss';

// eslint-disable-next-line react/prefer-stateless-function
export class BetHistoryPage extends Component {
    static defaultProps = {
        isSettled: false,
        isLoading: false,
        isExternalBetHistory: false,
        externalBetHistoryUrl: '',
        isExternalBetHistoryError: false,
        betHistoryErrors: null,
        isPageAfterNextRequested: false,
        hasNextPage: false,

    };

    static propTypes = {
        // #region required props
        apiName: PropTypes.string.isRequired,
        betHistory: PropTypes.arrayOf(betPropTypes).isRequired,
        currencySign: PropTypes.string.isRequired,
        pageLength: PropTypes.number.isRequired,
        currentPage: PropTypes.number.isRequired,
        // #endregion

        // #region props
        betHistoryErrors: PropTypes.objectOf(PropTypes.shape({
            message: PropTypes.string,
        })),
        isExternalBetHistory: PropTypes.bool,
        externalBetHistoryUrl: PropTypes.string,
        isExternalBetHistoryError: PropTypes.bool,
        isPageAfterNextRequested: PropTypes.bool,
        hasNextPage: PropTypes.bool,
        isSettled: PropTypes.bool,
        isLoading: PropTypes.bool,
        // #endregion

        // #region required events
        getBetHistory: PropTypes.func.isRequired,
        clearBetHistory: PropTypes.func.isRequired,
        betHistoryPageChange: PropTypes.func.isRequired,
        toggleIsSettled: PropTypes.func.isRequired,
        getExternalBetHistoryUrl: PropTypes.func.isRequired,
        clearExternalBetHistoryData: PropTypes.func.isRequired,
        // #endregion
    };

    componentWillMount() {
        const {
            apiName,
            getExternalBetHistoryUrl,
            isExternalBetHistory,
        } = this.props

        if (isExternalBetHistory) {
            getExternalBetHistoryUrl(apiName)
        }
    }

    componentWillUnmount() {
        this.props.clearExternalBetHistoryData();
    }

    render() {
        const {
            isSettled,
            isLoading,
            getBetHistory,
            clearBetHistory,
            betHistoryPageChange,
            toggleIsSettled,
            apiName,
            betHistory,
            currencySign,
            currentPage,
            isExternalBetHistory,
            externalBetHistoryUrl,
            isExternalBetHistoryError,
            betHistoryErrors,
            pageLength,
            isPageAfterNextRequested,
            hasNextPage,
        } = this.props;

        return isExternalBetHistory ? (
            <ExternalAccount
                windowName={'History'}
                externalAccountUrl={externalBetHistoryUrl}
                isExternalAccountError={isExternalBetHistoryError}
            />
        ) : (
            <BetHistoryIntegrated
                isSettled={isSettled}
                isLoading={isLoading}
                getBetHistory={getBetHistory}
                clearBetHistory={clearBetHistory}
                betHistoryPageChange={betHistoryPageChange}
                toggleIsSettled={toggleIsSettled}
                apiName={apiName}
                betHistory={betHistory}
                currencySign={currencySign}
                pageLength={pageLength}
                currentPage={currentPage}
                betHistoryErrors={betHistoryErrors}
                isPageAfterNextRequested={isPageAfterNextRequested}
                hasNextPage={hasNextPage}
            />
        );
    }
}

const userCurrencySignSelector =
    userInfoSelectors.createUserCurrencySignSelector(transitionRouterSelectors.feedSelector);

const bookmakerInfoSelector =
    bookmakersListSelectors.createBookmakerInfoSelector(
        transitionRouterSelectors.feedSelector,
    );

const mapDispatchToProps = {
    toggleIsSettled: accountActions.toggleIsSettled,
    getBetHistory: accountActions.getBetHistory,
    betHistoryPageChange: accountActions.betHistoryPageChange,
    clearBetHistory: accountActions.clearBetHistory,
    getExternalBetHistoryUrl: accountActions.getExternalBetHistoryUrl,
    clearExternalBetHistoryData: accountActions.clearExternalBetHistoryData,
};

const mapStateToProps = (state, props) => {
    const {
        isSettled,
        externalBetHistoryUrl,
        isExternalBetHistoryError,
    } = state.bookmakersSwitcher.accountPage;

    return {
        ...bookmakerInfoSelector(state, props),
        currencySign: userCurrencySignSelector(state, props),
        isSettled,
        currentPage: currentPageSelector(state),
        isLoading: pageIsLoadingSelector(state),
        betHistory: currentPageItemsSelector(state),
        betHistoryErrors: betHistoryErrorsSelector(state),
        externalBetHistoryUrl,
        isExternalBetHistoryError,
        pageLength: BET_HISTORY_PAGE_LENGTH,
        isPageAfterNextRequested: isPageAfterNextRequestedSelector(state),
        hasNextPage: hasNextPageSelector(state),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(BetHistoryPage);



// WEBPACK FOOTER //
// /src/js/bookmakersSwitcher/accountPage/components/betHistory/BetHistoryPage.jsx